import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { FieldValidationType } from '../../../sic-lib/enums/FieldValidationType';
import { ContactField } from '../../../sic-lib/types/ContactField';
import { toFriendlyFieldValidationType } from '../../../sic-lib/utils/contactFieldHelpers';
import DisplayContactFieldValue from '../DisplayContactFieldValue/DisplayContactFieldValue';
import MenuSetChannelValueRaw from './MenuSetChannelValueRaw/MenuSetChannelValueRaw';

const useStyles = makeStyles()((theme: Theme) => ({
    button: {
        fontStyle: 'italic',
        color: theme.palette.text.secondary,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
    btnPhone: {
        color: theme.palette.btnDefault.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
}));

interface Props {
    fieldLabel: string;
    fieldId: number;
    fieldType: FieldValidationType;
    fieldValue: string;
    options: ContactField<string>[];
    onSelectHandler: React.Dispatch<{
        fieldId: number;
        fieldValue: string;
        fieldLabel: string;
    }>;
}

export default function MenuSetChannelValue({
    fieldLabel,
    fieldId,
    fieldType,
    fieldValue,
    options,
    onSelectHandler,
}: Props) {
    const { classes, cx } = useStyles();

    const [menuId] = React.useState<string>('menu_set_channel_value');

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <Button
                aria-haspopup="true"
                aria-controls={menuId}
                aria-expanded={Boolean(anchorEl)}
                endIcon={<ArrowDropDownIcon />}
                onClick={handleOpen}
                //className={cx(options.length < 1 ? classes.button : classes.btnPhone)}
                variant="outlined"
            >
                {fieldLabel && `${fieldLabel}: `}
                {options.length < 1 ? (
                    `No ${toFriendlyFieldValidationType(fieldType)} Options`
                ) : (
                    <DisplayContactFieldValue fieldType={fieldType} fieldValue={fieldValue} />
                )}
            </Button>
            {anchorEl !== null && (
                <MenuSetChannelValueRaw
                    menuId={menuId}
                    anchorEl={anchorEl}
                    selectedFieldId={fieldId}
                    options={options}
                    onSelectHandler={onSelectHandler}
                    onCloseHandler={handleClose}
                />
            )}
        </React.Fragment>
    );
}
